/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSettingsQuery = {
  __typename?: 'Query',
  settings: {
    __typename?: 'ApplicationSettings',
    timestamp: number,
    applicationVersion: string,
    plugins?: Array<{
      __typename?: 'PluginValue',
      key: string,
      enabled?: boolean | null
    }> | null,
    settings?: Array<{
      __typename?: 'SettingValue',
      key: string,
      setting?: string | null
    }> | null,
    fields?: Array<{
      __typename?: 'FieldValue',
      key: string,
      fields: Array<string>
    }> | null,
    multiValues?: Array<{
      __typename?: 'MultiValue',
      key: string,
      multiValue?: string | null
    }> | null
  }
};

export type GetAdminSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAdminSettingsQuery = {
  __typename?: 'Query',
  adminSettings: {
    __typename?: 'AdminApplicationSettings',
    timestamp: number,
    settingsVersion: number,
    applicationVersion: string,
    categories?: Array<{
      __typename?: 'CategoryValue',
      id: number,
      name?: string | null
    }> | null,
    plugins?: Array<{
      __typename?: 'AdminPluginValue',
      key: string,
      description?: string | null,
      categoryId: number,
      typeId: number,
      value?: string | null,
      allowedValues?: Array<string> | null,
      visibility: number
    }> | null,
    fields?: Array<{
      __typename?: 'AdminFieldsValue',
      categoryId: number,
      name: string,
      description?: string | null,
      fields?: Array<{
        __typename?: 'AdminFieldValue',
        name: string,
        enabled?: boolean | null,
        accessUserTypes: Array<Types.Permission>
      }> | null
    }> | null
  }
};

export type GetAdminNavigationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAdminNavigationQuery = {
  __typename?: 'Query',
  adminNavigation: Array<{
    __typename?: 'NavigationItem',
    languageKey: string,
    icon?: string | null,
    url?: string | null,
    parameter?: Types.NavigationUrlParameter | null,
    permissions: Array<Types.Permission>,
    plugins: Array<string>,
    children: Array<{
      __typename?: 'NavigationItem',
      languageKey: string,
      icon?: string | null,
      url?: string | null,
      parameter?: Types.NavigationUrlParameter | null,
      permissions: Array<Types.Permission>,
      plugins: Array<string>
    }>
  }>
};

export type GetPublicSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPublicSettingsQuery = {
  __typename?: 'Query',
  publicSettings: {
    __typename?: 'ApplicationSettings',
    timestamp: number,
    applicationVersion: string,
    plugins?: Array<{
      __typename?: 'PluginValue',
      key: string,
      enabled?: boolean | null
    }> | null,
    settings?: Array<{
      __typename?: 'SettingValue',
      key: string,
      setting?: string | null
    }> | null,
    multiValues?: Array<{
      __typename?: 'MultiValue',
      key: string,
      multiValue?: string | null
    }> | null
  }
};

export type GetMaxFileSizeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMaxFileSizeQuery = {
  __typename?: 'Query',
  maxFileSize: number
};

export type GetLanguagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetLanguagesQuery = {
  __typename?: 'Query',
  languages: Array<{
    __typename?: 'Language',
    id: number,
    code: string,
    description: string,
    isApplicationLanguage: boolean,
    linkedLanguage: {
      __typename?: 'Language',
      id: number,
      code: string,
      description: string
    }
  }>
};

export type GetAllLanguageSetsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllLanguageSetsQuery = {
  __typename?: 'Query',
  languageSets?: Array<{
    __typename?: 'LanguageSetResult',
    language?: string | null,
    translations?: Array<{
      __typename?: 'LanguageKeyValuePair',
      key?: string | null,
      translation?: string | null
    }> | null
  }> | null
};

export type CustomerLanguageSetQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerLanguageSetQuery = {
  __typename?: 'Query',
  customerLanguageSet?: Array<{
    __typename?: 'CustomerLanguageSetResult',
    key?: string | null,
    timestamp?: number | null,
    translations?: Array<{
      __typename?: 'LanguageKeyValuePair',
      key?: string | null,
      translation?: string | null
    }> | null
  }> | null
};

export type LanguageSetByCodeQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
}>;


export type LanguageSetByCodeQuery = {
  __typename?: 'Query',
  languageSetByCode?: Array<{
    __typename?: 'LanguageKeyValuePair',
    key?: string | null,
    translation?: string | null
  }> | null
};

export type GetFaqCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFaqCategoriesQuery = {
  __typename?: 'Query',
  faqCategories?: Array<{
    __typename?: 'FaqCategory',
    id?: number | null,
    name?: string | null,
    sequenceNumber?: number | null,
    faqEntries?: Array<{
      __typename?: 'FaqEntry',
      id?: number | null,
      question?: string | null,
      sequenceNumber?: number | null,
      answer?: string | null
    }> | null
  }> | null
};

export type GetFaqEntriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFaqEntriesQuery = {
  __typename?: 'Query',
  faqEntries?: Array<{
    __typename?: 'FaqEntry',
    id?: number | null,
    question?: string | null,
    answer?: string | null,
    sequenceNumber?: number | null,
    category?: {
      __typename?: 'FaqCategory',
      id?: number | null,
      name?: string | null
    } | null
  }> | null
};

export type GetAdminFaqManualsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAdminFaqManualsQuery = {
  __typename?: 'Query',
  adminFaqManuals?: Array<{
    __typename?: 'FaqManual',
    id: number,
    permission?: Types.Permission | null,
    document?: {
      __typename?: 'Document',
      id: number,
      filename?: string | null
    } | null
  }> | null
};

export type GetAdminFaqSearchTermsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAdminFaqSearchTermsQuery = {
  __typename?: 'Query',
  adminFaqSearchTerms?: Array<{
    __typename?: 'FaqSearchTerm',
    id: number,
    searchTerm: string,
    count: number,
    lastSearchedOn?: number | null
  }> | null
};

export type GetPreloadLocationQueryVariables = Types.Exact<{
  locationId: Types.Scalars['Long']['input'];
  override?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetPreloadLocationQuery = {
  __typename?: 'Query',
  preloadLocation?: string | null
};

export type GetPreloadQueryVariables = Types.Exact<{
  type: Types.LocationType;
  override?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetPreloadQuery = {
  __typename?: 'Query',
  preload?: string | null
};


export const GetSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"applicationVersion"}},{"kind":"Field","name":{"kind":"Name","value":"plugins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"setting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"multiValue"}}]}}]}}]}}]} as unknown as DocumentNode<GetSettingsQuery, GetSettingsQueryVariables>;
export const GetAdminSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdminSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"settingsVersion"}},{"kind":"Field","name":{"kind":"Name","value":"applicationVersion"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plugins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"allowedValues"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"accessUserTypes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetAdminSettingsQuery, GetAdminSettingsQueryVariables>;
export const GetAdminNavigationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdminNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageKey"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"parameter"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"plugins"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageKey"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"parameter"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"plugins"}}]}}]}}]}}]} as unknown as DocumentNode<GetAdminNavigationQuery, GetAdminNavigationQueryVariables>;
export const GetPublicSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPublicSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"applicationVersion"}},{"kind":"Field","name":{"kind":"Name","value":"plugins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"setting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"multiValue"}}]}}]}}]}}]} as unknown as DocumentNode<GetPublicSettingsQuery, GetPublicSettingsQueryVariables>;
export const GetMaxFileSizeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMaxFileSize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxFileSize"}}]}}]} as unknown as DocumentNode<GetMaxFileSizeQuery, GetMaxFileSizeQueryVariables>;
export const GetLanguagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyApplicationLanguage"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"linkedLanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetAllLanguageSetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllLanguageSets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageSets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLanguageSetsQuery, GetAllLanguageSetsQueryVariables>;
export const CustomerLanguageSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customerLanguageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLanguageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<CustomerLanguageSetQuery, CustomerLanguageSetQueryVariables>;
export const LanguageSetByCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"languageSetByCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageSetByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]} as unknown as DocumentNode<LanguageSetByCodeQuery, LanguageSetByCodeQueryVariables>;
export const GetFaqCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFaqCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faqCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"faqEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]}}]} as unknown as DocumentNode<GetFaqCategoriesQuery, GetFaqCategoriesQueryVariables>;
export const GetFaqEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFaqEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faqEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetFaqEntriesQuery, GetFaqEntriesQueryVariables>;
export const GetAdminFaqManualsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdminFaqManuals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminFaqManuals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]} as unknown as DocumentNode<GetAdminFaqManualsQuery, GetAdminFaqManualsQueryVariables>;
export const GetAdminFaqSearchTermsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdminFaqSearchTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminFaqSearchTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"searchTerm"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"lastSearchedOn"}}]}}]}}]} as unknown as DocumentNode<GetAdminFaqSearchTermsQuery, GetAdminFaqSearchTermsQueryVariables>;
export const GetPreloadLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPreloadLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"override"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preloadLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"override"},"value":{"kind":"Variable","name":{"kind":"Name","value":"override"}}}]}]}}]} as unknown as DocumentNode<GetPreloadLocationQuery, GetPreloadLocationQueryVariables>;
export const GetPreloadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPreload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"override"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"override"},"value":{"kind":"Variable","name":{"kind":"Name","value":"override"}}}]}]}}]} as unknown as DocumentNode<GetPreloadQuery, GetPreloadQueryVariables>;